/* Shared mobile collection sheet, using the existing Mayfairsilk filter controls. */
(() => {
  let openSheet = null;
  let opener = null;
  let previousOverflow = '';
  const mobile = () => window.matchMedia('(max-width:699px)').matches;
  const updateLabel = () => {
    if (!openSheet) return;
    const count = openSheet.querySelector('.collection-toolbar__products-count')?.textContent?.trim();
    const button = openSheet.querySelector('.mfs-mobile-sheet-apply');
    if (button) button.textContent = count ? 'Show ' + count : 'Show products';
  };
  const close = () => {
    if (!openSheet) return;
    const toolbar = openSheet.closest('.collection-toolbar');
    toolbar?.classList.remove('mfs-mobile-filters-open');
    openSheet.removeAttribute('role');
    openSheet.removeAttribute('aria-modal');
    openSheet.removeAttribute('aria-label');
    opener?.setAttribute('aria-expanded','false');
    document.body.style.overflow = previousOverflow;
    const restore = opener;
    openSheet = null; opener = null;
    restore?.focus({preventScroll:true});
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mfs-sheet-open]');
    if (trigger && mobile()) {
      const toolbar = trigger.closest('.collection-toolbar');
      const panel = toolbar?.querySelector('.mfs-toolbar-center');
      if (!panel) return;
      if (openSheet) close();
      openSheet = panel;
      opener = trigger;
      previousOverflow = document.body.style.overflow;
      panel.setAttribute('role','dialog');
      panel.setAttribute('aria-modal','true');
      panel.setAttribute('aria-label','Filter and refine products');
      toolbar.classList.add('mfs-mobile-filters-open');
      updateLabel();
      trigger.setAttribute('aria-expanded','true');
      document.body.style.overflow = 'hidden';
      panel.querySelector('[data-mfs-sheet-close]')?.focus({preventScroll:true});
      return;
    }
    if (event.target.closest('[data-mfs-sheet-close]') && openSheet) close();
  });
  document.addEventListener('change', event => {if (openSheet?.contains(event.target)) queueMicrotask(updateLabel);});
  document.addEventListener('keydown', event => {
    if (!openSheet) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...openSheet.querySelectorAll('button:not([disabled]):not([hidden]),select:not([disabled]):not([hidden]),a[href],input:not([disabled])')].filter(el => el.getClientRects().length);
    if (!focusable.length) return;
    const first=focusable[0],last=focusable[focusable.length-1];
    if (event.shiftKey && document.activeElement===first) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && document.activeElement===last) {event.preventDefault();first.focus();}
  });
  window.matchMedia('(min-width:700px)').addEventListener('change', e => {if(e.matches) close();});
  document.addEventListener('shopify:section:unload', () => {if(openSheet)close();});
})();
